<template>
  <drag-dialog
    title="效果设置"
    :width="480"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="common-form-box">
      <el-form
        ref="form"
        class="public-form-primary"
        :model="form"
        label-width="116px">
        <el-form-item
          label="上传贴图："
          prop="texture"
          v-if="mode === 'single'">
          <div class="texture-uploader-box">
            <el-upload
              class="texture-uploader-box-content"
              ref="upload"
              drag
              :action="uploadUrl"
              :headers="headers"
              :data="uploadParams"
              name="FileInfo"
              accept=".jpg,.jpeg,.png,.gif,.tif,.psd"
              :show-file-list="false"
              :on-change="handleChange"
              :on-success="handleAvatarSuccess"
              :on-error="handleAvatarError"
              :auto-upload="false">
              <div
                v-if="form.imageSrc"
                class="avatar-box">
                <img
                  :src="`${imageBaseUrl}/${
                    form.imageSrc
                  }?token=${getTokenId()}`"
                  class="avatar" />
                <i
                  class="el-icon-delete icon"
                  @click="deleteImage"
                  title="删除贴图"></i>
              </div>
              <div
                v-else
                class="icon-box">
                <icon-svg
                  icon-class="ic-ico_upload"
                  size="32px"
                  class="icon" />
                <!-- <div><em class="text-btn">点击上传</em>/将文件拖到此处</div> -->
              </div>
            </el-upload>
            <div class="img-description public-tips-primary">
              支持jpg/png格式的图片，应用后生效
            </div>
          </div>
        </el-form-item>
        <el-form-item label="流速：">
          <div class="common-input-box">
            <el-input-number
              class="input-primary"
              v-model="form.flowRate"
              :step="0.1"
              :min="0"
              :max="2"></el-input-number>
          </div>
        </el-form-item>
        <el-form-item label="方向：">
          <el-radio-group
            v-model="form.direction"
            class="radio-group-box radio-primary">
            <el-radio :label="true">正向</el-radio>
            <el-radio :label="false">逆向</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="贴图拉伸倍数：">
          <div class="common-input-box">
            <el-input-number
              class="input-primary"
              v-model="form.compressionRatio"
              :min="0"
              :max="10"></el-input-number>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              :append-to-body="true"
              popper-class="common-dialog-tooltip-box">
              <div slot="content">
                <div class="compare-box">
                  <div class="item-box">
                    <div class="img-box">
                      <img src="@/assets/img/afterCompress.png" />
                    </div>
                    <div class="description">拉伸前</div>
                  </div>
                  <div class="arrow-box">
                    <img src="@/assets/img/arrow.png" />
                  </div>
                  <div class="item-box">
                    <div class="img-box">
                      <img src="@/assets/img/beforeCompress.png" />
                    </div>
                    <div class="description">拉伸后</div>
                  </div>
                </div>
                <div class="note-box">
                  注：不同的贴图拉伸倍数效果不同，可以通过设置图片的拉伸倍数，以达到最佳贴图效果
                </div>
              </div>
              <icon-svg
                icon-class="ic-wenhao1"
                class="description" />
            </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </drag-dialog>
</template>

<script>
import dragDialog from '@/components/CustomDragDialog.vue'
import logServeCof from '@/plugins/logServeCof.js'

import {
  getBase64,
  compressImgBySize,
  getToken,
  getTokenId
} from '@/utils/generalMethods'
const CompressSize = 2 * 1024 * 1024
export default {
  data() {
    return {
      mode: 'single',
      uploadUrl: this.getUploadUrl(),
      imageBaseUrl: window.imageBaseUrl,
      headers: {
        Authorization: this.getToken(),
        FileUploadScheme: 'Picture',
        FileUploadMode: 'Undivided'
      },
      uploadParams: {
        FileSize: '',
        FileType: '',
        Scheme: 'Picture'
      },

      form: {
        direction: true,
        flowRate: 1,
        compressionRatio: 1,
        imageSrc: ''
      }
    }
  },
  props: {
    visible: Boolean,
    textureInfo: Object,
    submitEffectInfo: Function,
    closeDialog: Function
  },
  components: {
    dragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initForm()
      }
    }
  },
  methods: {
    initForm() {
      let textureInfo = this.textureInfo
      if (textureInfo) {
        this.mode = 'single'
        this.form = {
          direction: textureInfo.direction ? true : false,
          flowRate: textureInfo.flowRate,
          compressionRatio: textureInfo.compressionRatio,
          imageSrc: textureInfo.imageSrc
        }
      } else {
        this.mode = 'batch'
      }
    },
    submit() {
      let startInterval = setInterval(() => {
        this.disabled = false
        clearInterval(startInterval)
      }, 60000)

      if (!this.disabled) {
        this.$refs.form.validate((bool, object) => {
          if (bool) {
            this.submitEffectInfo(this.form).then(response => {
              if (response.isSuccess) {
                this.disabled = false
                this.clearForm()
                this.closeDialog()
              } else {
                this.disabled = false
                this.$message.error(response.errMsg)
                return
              }
            })
          } else {
            this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
            this.disabled = false
            return
          }
          this.disabled = true
        })
      }
    },
    cancel() {
      this.clearForm()
      this.closeDialog()
    },
    clearForm() {
      this.mode = 'single'
      this.form = {
        direction: true,
        flowRate: 1,
        compressionRatio: 1,
        imageSrc: ''
      }
    },
    deleteImage(e) {
      e.stopPropagation()
      this.form.imageSrc = ''
    },
    handleChange(file) {
      let fileExtensName = file.name.substring(file.name.lastIndexOf('.') + 1)
      this.$set(this.uploadParams, 'FileType', fileExtensName)

      if (file.size < CompressSize) {
        this.$set(this.uploadParams, 'FileSize', file.size)
        this.$refs.upload.submit()
      } else {
        this.getBase64(file.raw).then(response => {
          this.compressImgBySize(response, 2 * 1024).then(res => {
            let fileOfBlob = new File([res], file.name)
            this.$set(this.uploadParams, 'FileSize', fileOfBlob.size)
            this.$set(this.uploadParams, 'FileInfo', fileOfBlob)
            this.$refs.upload.submit()
          })
        })
      }
    },
    handleAvatarSuccess(response, file) {
      // 图片上传成功
      if (response.isSuccess) {
        let data = response.data
        this.form.imageSrc = data.savePath
      } else {
        this.$message.error(response.errMsg)
      }
    },
    handleAvatarError() {
      this.$message.error('图片上传失败')
    },
    getUploadUrl() {
      const uploadUrl = `${
        window.serverUrl
      }/${logServeCof.logServeCof()}/project/fileManage/projectImage/upload`
      return uploadUrl
    },
    getBase64,
    compressImgBySize,
    getToken,
    getTokenId
  }
}
</script>

<style lang="less" scoped>
.common-form-box {
  .texture-uploader-box {
    /deep/ .el-upload-dragger {
      display: flex;
      width: 280px;
      height: 110px;
    }

    &-content {
      width: 280px;
      height: 110px;
    }

    .avatar-box {
      position: relative;
      width: 100%;
      height: 100%;
      .avatar {
        width: 100%;
        height: 100%;
      }
      .icon {
        position: absolute;
        top: 6px;
        right: 6px;
        color: var(--default-color);
        background: var(--base-bg-dark-color5);
        padding: 5px;
        border-radius: 50%;
        font-size: 12px;
      }
    }

    .icon-box {
      margin: auto;
      line-height: 25px;
      color: var(--base-dark4-color);
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon {
        color: var(--base-dark5-color);
        font-size: 32px;
      }
    }

    .img-description {
      line-height: 20px;
      margin-top: 4px;
    }
  }

  .common-input-box {
    display: flex;
    align-items: center;

    .el-input-number {
      width: 280px;
    }

    :deep(.el-input-number__increase) {
      right: 1px;
    }

    .description {
      width: 10px;
      margin-left: 10px;
      color: var(--default-color);
    }
  }

  .radio-group-box {
    display: inline-flex;
    width: 280px;
    justify-content: flex-start;

    // .el-radio {
    //   color: var(--default-color);
    // }
  }
}

.compare-box {
  display: flex;
  justify-content: space-between;

  .item-box {
    text-align: center;
    .img-box {
      width: 90px;
      height: 45px;
    }

    .description {
      margin-top: 10px;
    }
  }

  .arrow-box {
    display: flex;
    img {
      width: 25px;
      height: 45px;
      object-fit: contain;
    }
  }
}

.note-box {
  margin-top: 10px;
}
</style>
